import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  enviarChequeFisicoCc,
  enviarChequesFisicosCcLote,
} from "./ApiServices";
import { formatMoneda } from "../pago_proveedores/utils";
import { idInstrumentoFisico } from "./chequesFisicos.constants";

export default function ModalEnviarCC({
  open,
  onClose,
  cheques = [],
  onOk,
}) {
  const [obs, setObs] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const lista = Array.isArray(cheques)
    ? cheques.filter((c) => idInstrumentoFisico(c))
    : [];
  const lote = lista.length > 1;

  useEffect(() => {
    if (!open) return;
    setObs("");
    setError("");
  }, [open]);

  const guardar = async () => {
    if (!lista.length) return;
    setGuardando(true);
    setError("");
    try {
      const body = { obs: obs.trim() || undefined };
      if (lote) {
        await enviarChequesFisicosCcLote(
          lista.map((c) => idInstrumentoFisico(c)),
          body
        );
      } else {
        await enviarChequeFisicoCc(idInstrumentoFisico(lista[0]), body);
      }
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al enviar a Casa Central");
    } finally {
      setGuardando(false);
    }
  };

  const total = lista.reduce((acc, c) => acc + (Number(c.importe) || 0), 0);

  return (
    <Dialog
      open={open}
      onClose={guardando ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        {lote
          ? `Enviar a Casa Central (${lista.length} cheques)`
          : `Enviar a Casa Central — N° ${lista[0]?.nro_cheque || idInstrumentoFisico(lista[0]) || ""}`}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Typography variant="body2" color="text.secondary">
            El cheque físico queda en tránsito. En sucursal no se deposita ni se usa en
            OP hasta que Casa Central lo reciba. Total:{" "}
            <strong>{formatMoneda(total)}</strong>.
          </Typography>
          {lote ? (
            <Typography variant="caption" color="text.secondary">
              {lista
                .slice(0, 8)
                .map((c) => `N° ${c.nro_cheque || c.id}`)
                .join(", ")}
              {lista.length > 8 ? ` y ${lista.length - 8} más` : ""}
            </Typography>
          ) : null}
          <TextField
            label="Observaciones (opcional)"
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={obs}
            onChange={(e) => setObs(e.target.value)}
            disabled={guardando}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={guardando || !lista.length}
          startIcon={
            guardando ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          Enviar a Casa Central
        </Button>
      </DialogActions>
    </Dialog>
  );
}
